function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null);

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Workspace-Flow",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "April27_Workspace_5_",
  transform: "translate(-346.000000, -401.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "CheckedFilled",
  transform: "translate(346.000000, 401.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-8",
  fill: "#2CD589",
  x: 0,
  y: 0,
  width: 16,
  height: 16,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.762813,4.54804224 L12.4744581,4.24791762 C12.1572005,3.91736079 11.63796,3.91736079 11.3207024,4.24791762 L6.41866913,9.35003607 L4.67946564,7.5401937 C4.36254411,7.20998666 3.84296757,7.20998666 3.52604604,7.54054349 L3.23769114,7.84031831 C2.92076962,8.17052535 2.92076962,8.71095953 3.23769114,9.04116657 L5.84027894,11.7520824 C6.15753655,12.0826392 6.67677701,12.0826392 6.99403462,11.7520824 L12.762813,5.74889049 C13.0790623,5.41868346 13.0790623,4.87824927 12.762813,4.54804224 Z",
  id: "Shape",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}))));

var SvgCheckedFilled = function SvgCheckedFilled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckedFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CheckedFilled.16973011.svg";
export { ForwardRef as ReactComponent };